<div class="wrapper">
    <div class="header">
        <app-section-header [title]="'Companies'" [iconName]="'companies'" [actionsTemplate]="actionsTemplate">
            <ng-template #actionsTemplate>
                <div class="actions">
                    <button class="primary-btn" (click)="onCreateNewCompanyClicked()">
                        <span class="icon" [innerHTML]="plusIcon"></span> New Company
                    </button>
                </div>
            </ng-template>
        </app-section-header>

        <section class="filters">
            <app-companies-filters></app-companies-filters>
        </section>
    </div>

    <section class="tabGroup">
        <lib-tab-view [(currentTab)]="currentTab" [hasSteps]="false" [alignment]="'end'">
            <lib-tab-item tabName="List" [bodyTemplate]="list" [icon]="listIcon">
                <ng-template #list>
                    <section class="tab">
                        <app-companies-list></app-companies-list>
                    </section>
                </ng-template>
            </lib-tab-item>

            <lib-tab-item tabName="Map" [bodyTemplate]="map" [icon]="mapIcon">
                <ng-template #map>
                    <section class="tab">
                        <app-companies-map></app-companies-map>
                    </section>
                </ng-template>
            </lib-tab-item>
        </lib-tab-view>
    </section>
</div>
